import PropTypes from "prop-types";
import {
  CartesianGrid,
  Line,
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import getRandomColor from "../../utils/randomColors";
// import CustomizedLabel from "./customLabel";
import CustomizedAxisTick from "./customTick";

const MyLine = ({ data, width, yunit }) => {
  // https://recharts.org/zh-CN/examples/SimpleBarChart
  const keys = Object.keys(data[0]).filter((key) => key !== "name");

  return (
    <ResponsiveContainer width={width} height="100%">
      <LineChart data={data} margin={{ top: 15, right: 20, bottom: 5, left: 15 }}>
        {keys.map((key) => (
          <Line key={key} dataKey={key} stroke={getRandomColor()} />
        ))}
        <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
        <XAxis dataKey="name" padding={{ left: 15, right: 15 }} tick={<CustomizedAxisTick />} />
        <YAxis allowDecimals={false} unit={yunit} domain={["auto", "auto"]} />
        <Tooltip />
      </LineChart>
    </ResponsiveContainer>
  );
};

MyLine.defaultProps = {
  data: [],
  width: 300,
  yunit: "",
};

MyLine.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  width: PropTypes.number,
  yunit: PropTypes.string,
};
export default MyLine;
